module.exports = __webpack_public_path__ + "img/content1-4.2b8757fb.webp";